import React, { Component } from "react";
import styled from "styled-components";

const StyledImage = styled.img`
  width: 100%;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }
`;

class Image extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageLoaded: false,
    };
  }

  handleLoad = () => {
    this.setState({ imageLoaded: true });
  };

  render() {
    let { src, srcSmall, className, alt, style } = this.props;
    const { imageLoaded } = this.state;
    srcSmall = srcSmall ? srcSmall : src;
    if (imageLoaded) {
      return (
        <div style={{ marginBottom: 15, overflow: "hidden" }}>
          <StyledImage
            src={this.state.imageLoaded ? src : srcSmall}
            onLoad={this.handleLoad}
            className={className}
            alt={alt}
            style={style}
          />
        </div>
      );
    } else {
      return (
        <div style={{ marginBottom: 15, overflow: "hidden" }}>
          <StyledImage
            src={srcSmall}
            onLoad={this.handleLoad}
            className={`${className} blur`}
            alt={alt}
            style={style}
          />
        </div>
      );
    }
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.jsx